import React, { createContext, useState, ReactNode, useContext } from 'react';

interface SupabaseStatusContextType {
    hasConnectionError: boolean;
    setHasConnectionError: (hasError: boolean) => void;
}

const SupabaseStatusContext = createContext<SupabaseStatusContextType | undefined>(undefined);

export const SupabaseStatusProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [hasConnectionError, setHasConnectionError] = useState(false);
    
    const value = { hasConnectionError, setHasConnectionError };

    return (
        <SupabaseStatusContext.Provider value={value}>
            {children}
        </SupabaseStatusContext.Provider>
    );
};

export const useSupabaseStatus = (): SupabaseStatusContextType => {
    const context = useContext(SupabaseStatusContext);
    if (context === undefined) {
        throw new Error('useSupabaseStatus must be used within a SupabaseStatusProvider');
    }
    return context;
};
